// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".subscriptions-footer{position:absolute;bottom:calc(env(safe-area-inset-bottom) + 49px);left:0;right:0}.has-subscriptions-footer{bottom:calc(env(safe-area-inset-bottom) + 49px + 66px) !important}", ""]);
// Exports
module.exports = exports;
